import React, { Component } from "react";
import messages from './ResetPassword.messages';
import {Grid, Row, Col, Button} from 'react-bootstrap/lib';
import { Link } from 'react-router-dom';
import ResetForm from '../../../components/forms/reset-form/ResetForm'

type Props = {
  onRequestSendPasswordResetEmail: () => void;
  showInvalidEmailError: () => void;
  redirectToLogin: () => void;
}

export default class Login extends Component {

  props: Props;

  handleRegisterRedirect = (event) => {
    event.preventDefault();
    this.props.redirectToRegister();
  }

  render() {
    return (
      <div>
        <h1 className='loope-title'>{messages.reset}</h1>
        {this.renderInvalidEmailError()}
        <div className="row">
          <div className="col-xs-12 col-md-8 offset-md-2 col-lg-4 offset-lg-4">
            <ResetForm
              onRequestSendPasswordResetEmail={this.props.onRequestSendPasswordResetEmail}
              handleShowLogin={this.props.redirectToLogin}
              >
            </ResetForm>
            <Link to='/login'
              className='login-link'>
              {messages.backToLogin}
            </Link>
          </div>
        </div>
      </div>
    );
  }

  renderInvalidEmailError() {
    if (!this.props.showInvalidEmailError) {
      return;
    }
    return (
      <div>
        <p>{messages.invalidError}</p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/guest/reset-password/ResetPassword.js